module.exports = __webpack_public_path__ + "static/media/servizi_postali.8b9634db.png";